// extracted by mini-css-extract-plugin
module.exports = {"campaignForm":"jrrFF0b5ikKMsvoBPCw7H","campaignList":"_17n9JDZ5WQwTW9apr8ijUO","campaignLabel":"_3hIqi1I9nl1SaoILFokyhp","name":"_26PFZlEhuQOP9OF1HuYyoP"};